import { TextFieldProps, TextField, InputAdornment, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { MdOutlineSearch } from 'react-icons/md';

interface Props extends Omit<TextFieldProps, 'name'> {
  debounceTime?: number;
  searchText: null | string;
  setSearchText: (value: string | null) => void;
}

export default function Search({ debounceTime = 800, searchText = '', setSearchText, ...inputFieldProps }: Props) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const size = inputFieldProps.size || (isLargeScreen ? 'medium' : 'small');
  const [value, setValue] = useState<null | string>(searchText);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchText(value);
    }, debounceTime);

    return () => {
      clearTimeout(timer);
    };
  }, [value, setSearchText, debounceTime]);

  return (
    <TextField
      {...inputFieldProps}
      size={size}
      value={value || ''}
      onChange={(e) => setValue(e.target.value)}
      sx={{
        '& .MuiOutlinedInput-root': {
          background: '#fff',
          '& fieldset': {
            borderColor: '#ececec'
          }
        }
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position='start'>
              <MdOutlineSearch color='rgba(0,0,0,0.25)' />
            </InputAdornment>
          )
        }
      }}
    />
  );
}
